export const PRINT_OPTIONS = {
  PRINT_PER_PATIENT: 'PRINT_PER_PATIENT',
  PRINT_MEDICATION: 'PRINT_MEDICATION',
  PRINT_REPEATS_REMAINING: 'PRINT_REPEATS_REMAINING',
};
export const PRINT_OPTIONS_DATA = [
  // mapKey: redux key
  { label: 'Separate request per patient', value: PRINT_OPTIONS.PRINT_PER_PATIENT, mapKey: 'isPrintPerPatient' },
  {
    label: 'Medication Profile on Script Request',
    value: PRINT_OPTIONS.PRINT_MEDICATION,
    mapKey: 'isIncludeMedicationDetails',
  },
  {
    label: 'Repeats Remaining',
    value: PRINT_OPTIONS.PRINT_REPEATS_REMAINING,
    mapKey: 'isRepeatsRemaining',
  },
];

export const PRINT_OPTION_STORAGE_KEY = 'printOptionStorage';

export const PRESCRIPTIONS_STATUS = {
  CEASED: 'CEASED',
};

export const DRUG_STATUS = {
  PACKED: 'PACKED',
  NON_PACKED: 'NON_PACKED',
  PACKED_PRN: 'PACKED_PRN',
};

export const DRUG_STATUS_OPTIONS = [
  { label: 'Packed', value: DRUG_STATUS.PACKED },
  { label: 'Non-Packed', value: DRUG_STATUS.NON_PACKED },
  { label: 'Packed/Non-Packed PRN', value: DRUG_STATUS.PACKED_PRN },
];

export const PRESCRIPTIONS_STATUS_FILTER = { label: 'Ceased', value: PRESCRIPTIONS_STATUS.CEASED };

export const PATIENT_OPTIONS = {
  INCLUDE_SUSPENDED: 1,
};
export const PATIENT_OPTIONS_FILTER = [
  {
    label: 'Suspended Patients',
    value: PATIENT_OPTIONS.INCLUDE_SUSPENDED,
  },
];
